import { Inject, Injectable } from '@angular/core';
import { Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../setting/auth.service';
import { API_CONFIG } from './config';
import { ITokenModel, ITokenService, SERVICE_TOKEN } from './token/interface';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(
    private router: Router,
    private authService: AuthService,
    @Inject(SERVICE_TOKEN) private srv: ITokenService,
  ) {}

  private process(): boolean {
    let model = this.srv.get() as ITokenModel;
    let res = this.checkToken(model);
    if (!res && API_CONFIG.token_invalid_redirect === true) {
      //this.authService.deleteAllLocalInfo();
      this.router.navigate([API_CONFIG.login_url]);
    }
    return res;
  }

  // lazy loading
  canLoad(route: Route, _segments: UrlSegment[]): boolean {
    return this.process();
  }
  // all children route
  canActivateChild(_childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.process();
  }
  // route
  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.process();
  }

  /**
   * アクセストークンがあるかどうかをチェックする
   * アクセストークンが自動的にリフレッシュされたので、アクセストークンは常に有効
   */
  checkToken(model: ITokenModel | null): boolean {
    return model != null && typeof model.accessToken === 'string' && model.accessToken.length > 0;
  }
}
